import {makeAutoObservable, runInAction} from "mobx";
import {User} from "../../entity/model/user";
import {Auth} from "aws-amplify";
import UserAgent from "../agent/user-agent";
import {RequestBody} from "../../entity/core/request-body";

export default class UserStore {
  users: User[] = [];
  currentUser: User | undefined = undefined;
  isLoggedIn = false;
  cache = false;
  userAgent: UserAgent;

  constructor(userAgent: UserAgent) {
    makeAutoObservable(this);
    this.userAgent = userAgent;
  }

  getCurrentUser = async (): Promise<User | undefined> => {
    try {
      this.currentUser = await this.userAgent.getCurrentUser();
      this.isLoggedIn = true;
    } catch (error: any) {
      console.error('Error occurred while fetch current user', error);
    }

    return this.currentUser;
  }

  getUserById = async (userId: string): Promise<User | undefined> => {
    try {
      return await this.userAgent.getUserById(userId);
    } catch(error:any) {
      console.error('Error occurred while fetch user', error);
    }
  }

  getAllUsers = async (organizationId: string): Promise<User[]> => {
    try {
      this.users = await this.userAgent.getAllUsers(organizationId);
      this.cache = true;
    } catch (error: any) {
      console.error('Error occurred while loading the users', error);
    }

    return this.users;
  }

  createUser = async (organizationID: string, requestBody: RequestBody): Promise<string | undefined> => {
    try {
      const response = await this.userAgent.createUser(organizationID, requestBody);
      if (response)
        this.cache = false;
    } catch (error: any) {
      console.error('Error occurred while creating the user', error);
      return 'Error occurred while creating the user !!';
    }
  }

  updateUser = async (organizationId: string, userId: string, requestBody: RequestBody): Promise<string | undefined> => {
    try {
      const response = await this.userAgent.updateUser(organizationId, userId, requestBody);
      if (response)
        this.cache = false;
    } catch (error: any) {
      console.error('Error occurred while updating the user', error);
      return 'Error occurred while updating the user !!';
    }
  }

  deleteUser = async (organizationId: string, userId: string): Promise<string | undefined> => {
    try {
      await this.userAgent.deleteUser(organizationId, userId);
      this.cache = false;
    } catch (error: any) {
      console.error('Error occurred while deleting the user', error);
      return 'Error occurred while deleting the user !!';
    }
  }

  logout = async (): Promise<string | undefined> => {
    try {
      await Auth.signOut();

      runInAction(() => {
        this.isLoggedIn = false;
        this.currentUser = undefined;
      });
    } catch (error: any) {
      console.error('Error occurred while logout the user', error);
      return 'Error occurred while logout the user !!';
    }
  }
}
